module.exports = __webpack_public_path__ + "media/images/favicon-04985418ae3f9a2ffbee16100542ceb0.png";